<style scoped>
    .line{
        white-space: nowrap;
    }
</style>
<template>
    <div>
        <Poptip @on-popper-show="popShow">
            <div class="link">
                <slot>查看库存</slot>
            </div>
            <div slot="content">
                <Spin v-if="loading" fix></Spin>
                <div class="line" v-for="stock in stocks" :key="stock.id">
                    {{stock.warehouse_name}}: {{stock.qty}}
                </div>
                <div class="line" v-if="stock_empty">暂无库存信息</div>
                <div class="line" v-if="err_msg">
                    {{err_msg}}
                </div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    export default {
        props: {
            stock_id: {
                type: Number,
                default: 0
            }
        },
        data(){
            return {
                loading: false,
                stocks: [],
                stock_empty: false,
                err_msg: ''
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            popShow(){
                this.stocks = [];
                this.stock_empty = false;
                this.err_msg = '';
                this.getStockInfo();
            },
            getStockInfo(){
                if(!this.stock_id) return;
                this.loading = true;
                Util.ajax.get(Util.api.stock_qty, {
                    params: {
                        id: this.stock_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    console.log(res);
                    if(res.code === 1){
                        let data = res.data;
                        this.stocks = data.stocks;
                        if(this.stocks.length === 0){
                            this.stock_empty = true;
                        }
                    }else{
                        this.err_msg = res.msg;
                        //this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            }
        }
    }
</script>
